import classNames from 'classnames'

import Button from '@/components/base/Button'
import Image from '@/components/base/Image'
import ImageParallax from '@/components/base/ImageParallax'
import Typography from '@/components/base/Typography'

import { WPImage, WPLink, WPTaxonomy } from '@/types'

export type ProjectCardProps = Partial<{
  uuid: number
  image: WPImage
  title: string
  badge: string
  overline: string
  paragraph: string
  link: WPLink
  taxonomy: WPTaxonomy
}>

const ProjectCard = ({
  image,
  title,
  badge,
  overline,
  paragraph,
  link
}: ProjectCardProps) => {
  return (
    <div
      className="aspect-h-[390] aspect-w-[350] lg:aspect-h-[480] lg:aspect-w-[605]"
      data-motion-project-card
    >
      <div
        className={classNames(
          'before:absolute before:left-0 before:top-0 before:h-full before:w-full before:rounded-xs before:bg-blue',
          'after:absolute after:left-0 after:top-0 after:h-full after:w-full after:rounded-xs after:bg-black/40'
        )}
      >
        <ImageParallax fill className="rounded-xs">
          {(ref) => (
            <Image
              fill
              ref={ref}
              size="large"
              loading="lazy"
              source={image}
              alt={image?.alt}
              className="rounded-xs"
            />
          )}
        </ImageParallax>
      </div>
      <div className="flex items-end p-gutter">
        <div className="grid gap-y-sm">
          {badge ? (
            <div className="flex">
              <span className="inline-flex rounded-full bg-white px-[1rem] pb-[.5rem] pt-[.7rem]">
                <Typography variant="small" className="uppercase text-pink">
                  {badge}
                </Typography>
              </span>
            </div>
          ) : null}

          {overline ? (
            <Typography variant="small" paragraph className="text-white">
              {overline}
            </Typography>
          ) : null}

          {title ? (
            <Typography variant="h5" component="h5" className="text-white">
              {title}
            </Typography>
          ) : null}

          {paragraph ? (
            <Typography variant="body" paragraph className="text-white">
              {paragraph}
            </Typography>
          ) : null}

          {link ? (
            <div>
              <Button href={link?.url} link variant="contained">
                {link?.title}
              </Button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  )
}

export default ProjectCard
